import { apiInstance } from '@crm/shared/api';
import { keysToCamel } from '@crm/shared/lib/objects';

import { dealsBoardApiRoutes } from './api-routes';

import type { TDealColumn, TDealsBoardResponseDto, TSortDealColumnPayload } from '../model';

export const dealsBoardApi = {
    getDealsBoard: async () => {
        const response = await apiInstance(
            dealsBoardApiRoutes.getDealsBoardRoute()
        ).json<TDealsBoardResponseDto>();

        return keysToCamel(response.data);
    },
    sortDealColumn: async ({ targetColumnIds }: TSortDealColumnPayload) => {
        const formData = new FormData();
        const timestamp = Date.now();
        const data = {
            'column_ids': targetColumnIds,
        };
        const q = [
            {
                t: timestamp,
                data: {
                    type: 'sort-crm-deal-columns',
                    data,
                },
            },
        ];

        formData.append('t', String(timestamp));
        formData.append('q', JSON.stringify(q));

        return apiInstance.post(dealsBoardApiRoutes.sortDealColumnRoute(), {
            body: formData,
        });
    },
    editColumnData: async ({
        columnId,
        title,
        color,
    }: {
        columnId: TDealColumn['id'];
        title: TDealColumn['title'];
        color: TDealColumn['color'];
    }) => {
        const body = JSON.stringify({
            title,
            color,
        });
        return apiInstance.patch(dealsBoardApiRoutes.editColumnDataRoute(columnId), {
            body,
        });
    },
    deleteColumn: async ({ columnId }: { columnId: TDealColumn['id'] }) =>
        apiInstance.delete(dealsBoardApiRoutes.editColumnDataRoute(columnId)),
    createColumn: async ({
        title,
        color,
    }: {
        title: TDealColumn['title'];
        color: TDealColumn['color'];
    }) => {
        const body = JSON.stringify({
            title,
            color,
        });
        return apiInstance.post(dealsBoardApiRoutes.createColumnRoute(), {
            body,
        });
    },
};
